'use es6';

import ActionTypes from '../actions/ActionTypes';
export const INITIAL_STATE = {
  isModalOpen: false,
  modalTriggerSource: null,
  showTooltip: false
};
export default function AcademyToSoftware(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ActionTypes.ACADEMY_TO_SOFTWARE_SET_MODAL_OPEN:
      {
        return Object.assign({}, state, {
          isModalOpen: true,
          modalTriggerSource: action.payload.SOURCE,
          selectedSoftware: action.payload.SELECTEDSOFTWARE
        });
      }
    case ActionTypes.ACADEMY_TO_SOFTWARE_SET_MODAL_CLOSED:
      {
        return Object.assign({}, state, {
          isModalOpen: false
        });
      }
    case ActionTypes.ACADEMY_TO_SOFTWARE_SHOW_TOOLTIP:
      {
        return Object.assign({}, state, {
          showTooltip: true
        });
      }
    case ActionTypes.ACADEMY_TO_SOFTWARE_HIDE_TOOLTIP:
      {
        return Object.assign({}, state, {
          showTooltip: false
        });
      }
    default:
      {
        return state;
      }
  }
}